import { render, staticRenderFns } from "./MapRoles.vue?vue&type=template&id=5e3a1319&scoped=true&"
import script from "./MapRoles.vue?vue&type=script&lang=ts&"
export * from "./MapRoles.vue?vue&type=script&lang=ts&"
import style0 from "./MapRoles.vue?vue&type=style&index=0&id=5e3a1319&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a1319",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VSimpleTable,VSpacer})
